import dashjs from '../../../../dash.js'
import is from '../utils/is';
import browser from '../utils/browser';

const dash = {
  isdash(url) {
    if (is.array(url)) {
      const [{src},] = url;
      url = src;
    }
    if (/^https?:\/\/[a-zA-Z0-9.\/?=_%&:-]+(?:.mpd|\(dash\))/.test(url)) {
      return true;
    }
    return false;
  },

  setup(path) {

    const player = this;
    let url = path;
    if (is.array(url)) {
      const [{src},] = url;
      url = src;
    }

    return new Promise((resolve, reject) => {
      if (url === "") {
        reject();
      }

      if (browser.isSafari) {
        console.log("Can not support Safari."); 
        reject();
      }

      // if (dash.isdash.call(this, url)) {
        let bitratesinfo = [];

        function updateQuality(newQuality) {
          let settingsp = player.dash.getSettings();
          //console.log(newQuality);
          if(newQuality === 0)
          {
            const cfg = {streaming: {abr: {autoSwitchBitrate: {video: true}}}};
            player.dash.updateSettings(cfg);

            console.log(player.dash.getQualityFor("video"));
          }
          else
          {
            const cfg = {streaming: {abr: {autoSwitchBitrate: {video: false}}}};
            player.dash.updateSettings(cfg);

            for (var i=0; i<bitratesinfo.length; i++)
            {
              if(bitratesinfo[i].height == newQuality)
              {
                player.dash.setQualityFor("video", bitratesinfo[i].qualityIndex, true);
                break;
              }
            }          
          }

          console.log("here set:",newQuality," ,if auto switch quality",settingsp.streaming.abr.autoSwitchBitrate);
          console.log("getQualityFor('video') : ", player.dash.getQualityFor('video'));
        }      

        if (this.dash) {
          this.dash.destroy();
          this.dash = null;
        }
        
        this.dash = dashjs.MediaPlayer().create();
        // window.dash = dash;

        const initialConfig = {
            debug: {
                logLevel: dashjs.Debug.LOG_LEVEL_NONE //LOG_LEVEL_INFO LOG_LEVEL_NONE
            },
            streaming: {
                buffer: {
                  fastSwitchEnabled: true,
                  //reuseExistingSourceBuffers: true
                },
                abr: {
                  autoSwitchBitrate: {
                      video: true
                  },
                  // useDefaultABRRules: true,
                  // ABRStrategy: 'abrThroughput',
                  // additionalAbrRules: {
                  //   insufficientBufferRule: true,
                  //   switchHistoryRule: false,
                  //   droppedFramesRule: false,
                  //   abandonRequestsRule: false
                  // }
                }
            }
        };

        this.dash.updateSettings(initialConfig);

        this.dash.initialize(this.media, url, true); 
        if (player.config.starplayer.protectionData !== undefined) {
          this.dash.setProtectionData(player.config.starplayer.protectionData);
        }

        this.dash.on(dashjs.MediaPlayer.events.QUALITY_CHANGE_RENDERED, (event) => {
          console.log(event);

          if (bitratesinfo.length > 0) {
            const quality = event.newQuality;
            player.hlsquality = bitratesinfo[quality].height;

            const settingsp = player.dash.getSettings();
            if (settingsp.streaming.abr.autoSwitchBitrate.video) {
              var settingmenu = document.querySelector(".plyr__menu__container [data-plyr='settings'][value='quality'] span span");
              if (settingmenu) {
                settingmenu.innerHTML = `Auto (${bitratesinfo[quality].height}p)`;
              }
            } 
            var qualitymenu = document.querySelector(".plyr__menu__container [data-plyr='quality'][value='0'] span");
            if (qualitymenu) {
              if (settingsp.streaming.abr.autoSwitchBitrate.video) {
                qualitymenu.innerHTML = `Auto (${bitratesinfo[quality].height}p)`;
              } else {
                qualitymenu.innerHTML = "Auto";
              }
            }
          }
        });

        this.dash.on(dashjs.MediaPlayer.events.QUALITY_CHANGE_REQUESTED, (event) => {
          console.log(event);          
        });

        this.dash.on(dashjs.MediaPlayer.events.REPRESENTATION_SWITCH, (event) => {
          console.log(event);
        });

        this.dash.on(dashjs.MediaPlayer.events.ERROR, (event) => {
          console.log(event); 
          if (event.error.code == dashjs.MediaPlayer.errors.DOWNLOAD_ERROR_ID_MANIFEST_CODE) {
            reject();
          } 
        });

        const defaultOptions = {};
        this.dash.on(dashjs.MediaPlayer.events.STREAM_INITIALIZED, function () {
          bitratesinfo = player.dash.getBitrateInfoListFor("video");

          const availableQualities = bitratesinfo.map((l) => l.height);
          if (availableQualities[0] !== undefined) {
            availableQualities.unshift(0); //prepend 0 to quality array
            availableQualities.sort((a, b) => b - a);
          }
                
          defaultOptions.quality = {
            default: 0,
            options: availableQualities,
            forced: true,        
            onChange:(e) => updateQuality(e),
          }
          console.log(availableQualities);

          resolve(defaultOptions.quality);
        });
      // } else {
      //   reject();
      // }
    });

    
  },
};

export default dash;